import css from 'styled-jsx/css'

export const responsiveContainerStyles = css`
  .responsive-container {
    position: relative;
    display: flex;
  }
  .responsive-container:before {
    content: '';
    display: block;
  }
  .responsive-container-body {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
  }
  .responsive-container-content {
    flex: 1;
    display: flex;
    position: relative;
    height: 100%;
    width: 100%;
    flex-direction: column;
  }
  .ratio-16-9 {
    padding-top: 56.25%;
  }
  .ratio-1-1 {
    padding-top: 100%;
  }
  .ratio-2-1 {
    padding-top: 50%;
  }
  .ratio-1-120 {
    padding-top: 120%;
  }
`